



























import Vue from 'vue';
import EnemYearSelectionForm from '@/components/forms/EnemYearSelectionForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import pipeline from '@/pipeline';
import { Toast } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    EnemYearSelectionForm,
    PipelineMenuWrapper,
    BackButton,
    Toast,
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    availableEnemYears(): string[] {
      return this.$store.getters.availableEnemYears || [];
    },
    selectedEnemYear(): string {
      return this.$store.getters.enem?.year;
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_ENEM_YEARS');
  },
  methods: {
    async selectedHandler(year: string) {
      await this.$store
        .dispatch('UPDATE_ENEM', { enem: { year } })
        .catch(error => this.errorHandler(error));

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
